import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserwayService {

  constructor(
    @Inject(DOCUMENT) private document: Document
  ) { }


  private script: HTMLScriptElement | null = null

  userwayEnabled: boolean = false

  embedUserwayScript() {
    const script = this.document.createElement("script");
    /* uncomment the following line to override default position*/
    script.setAttribute("data-position", "3");
    /* uncomment the following line to override default size (values: small, large)*/
    /* script.setAttribute("data-size", "large");*/
    /* uncomment the following line to override default language (e.g., fr, de, es, he, nl, etc.)*/
    /* script.setAttribute("data-language", "null");*/
    /* uncomment the following line to override color set via widget (e.g., #053f67)*/
    script.setAttribute("data-color", "#55C1AC");
    /* uncomment the following line to override type set via widget (1=person, 2=chair, 3=eye, 4=text)*/
    /* script.setAttribute("data-type", "1");*/
    /* script.setAttribute("data-statement_text:", "Our Accessibility Statement");*/
    /* script.setAttribute("data-statement_url", "http://www.example.com/accessibility";*/
    /* uncomment the following line to override support on mobile devices*/
    /* script.setAttribute("data-mobile", true);*/
    /* uncomment the following line to set custom trigger action for accessibility menu*/
    /* script.setAttribute("data-trigger", "triggerId")*/
    script.setAttribute("data-account", "w6OV6uoh4T");
    script.setAttribute("src", "https://cdn.userway.org/widget.js");
    (this.document.body || this.document.head).appendChild(script);
    this.script = script
    this.userwayEnabled = true
  }

  removeUserwayScript() {
    if (this.script) {
      this.script.remove()
      this.script = null
      this.userwayEnabled = false
    }
  }

}
